import React from "react";
import {File} from '../iconsSvg'
// components
import Carousel from "../Carousel";
import SenderWrapper from "./Sender/wrapper";

import Smile_A from '../../components/smileImg/smile1.png';
import Smile_B from '../../components/smileImg/smile2.png';
import Smile_C from '../../components/smileImg/smile3.png';
import Smile_D from '../../components/smileImg/smile4.png';
import Smile_E from '../../components/smileImg/smile5.png';
import Smile_F from '../../components/smileImg/smile6.png';
import Smile_G from '../../components/smileImg/smile7.png';

export function TEXT(payload) {
    const linkUniq = text => {
        let arr = text.split(/(\s+)/);
        const res = arr.map(it => {
            if (it.indexOf('http://') !== -1 || it.indexOf('https://') !== -1) {
                if (it.slice(-1) === '.') {
                    it = it.slice(0, -1)
                }
                return <a href={`${it.trim()}`} target="_blank">{it.trim()}</a>
            } else if (it.indexOf('@') !== -1) {
                let mail = it.replace(/mailto:/g, '');
                if (mail.slice(-1) === '.') {
                    mail = mail.slice(0, -1)
                }
                return <a href={`mailto:${mail.trim()}`} target="_blank">{mail.trim()}</a>
            } else {
                return it + ' '
            }
        });

        return res;
    }

    if (payload.text && payload.text.indexOf('♢') !== -1) {
        let tempArr = payload.text.split("♢:");
        let operatorF = '';
        let linkFirst = '';

        tempArr.map(elem => {
            let trimElement = elem.trim();

            if (elem.indexOf('@') !== -1) {
                if (elem.indexOf(':♢')) {
                    let nextWord = elem.slice(elem.indexOf('♢') + 1);
                    let mail = nextWord.replace(/mailto:/g, '');
                    if (mail.slice(-1) === '.') {
                        mail = mail.slice(0, -1)
                    }
                    linkFirst = `<a href=${`mailto:${mail.trim()}`} target="_blank">${mail.trim()}</a>`
                } else {
                    let mail = elem.replace(/mailto:/g, '');
                    if (mail.slice(-1) === '.') {
                        mail = mail.slice(0, -1)
                    }
                    linkFirst = `<a href=${`mailto:${mail.trim()}`} target="_blank">${mail.trim()}</a>`
                }
            }

            if (trimElement.indexOf('♢') !== -1) {
                let word = trimElement.slice(0, trimElement.indexOf(':♢'));
                let nextWord = elem.slice(elem.indexOf(':♢') + 2);

                if (nextWord.indexOf('@') !== -1) {
                    let mail = nextWord.replace(/mailto:/g, '');
                    if (mail.slice(-1) === '.') {
                        mail = mail.slice(0, -1)
                    }
                    nextWord = `<a href=${`mailto:${mail.trim()}`} target="_blank">${mail.trim()}</a>`
                }

                let equalLink = nextWord === linkFirst ? '' : nextWord;

                switch (word.trim()) {
                    case 'smiley':
                        operatorF = linkFirst ? linkFirst + `<img src='${Smile_A}' />` + equalLink : operatorF + `<img src='${Smile_A}' />` + nextWord;
                        return <SenderWrapper text={operatorF}/>
                    case 'sad':
                        operatorF = linkFirst ? linkFirst + `<img src='${Smile_B}' />` + equalLink : operatorF + `<img src='${Smile_B}' />` + nextWord;
                        return <SenderWrapper text={operatorF}/>
                    case 'wink':
                        operatorF = linkFirst ? linkFirst + `<img src='${Smile_C}' />` + equalLink : operatorF + `<img src='${Smile_C}' />` + nextWord;
                        return <SenderWrapper text={operatorF}/>
                    case 'angry':
                        operatorF = linkFirst ? linkFirst + `<img src='${Smile_D}' />` + equalLink : operatorF + `<img src='${Smile_D}' />` + nextWord;
                        return <SenderWrapper text={operatorF}/>
                    case 'oh':
                        operatorF = linkFirst ? linkFirst + `<img src='${Smile_E}' />` + equalLink : operatorF + `<img src='${Smile_E}' />` + nextWord;
                        return <SenderWrapper text={operatorF}/>
                    case 'like':
                        operatorF = linkFirst ? linkFirst + `<img src='${Smile_F}' />` + equalLink : operatorF + `<img src='${Smile_F}' />` + nextWord;
                        return <SenderWrapper text={operatorF}/>
                    case 'unlike':
                        operatorF = linkFirst ? linkFirst + `<img src='${Smile_G}' />` + equalLink : operatorF + `<img src='${Smile_G}' />` + nextWord;
                        return <SenderWrapper text={operatorF}/>
                    default:
                        return ''
                }
            } else {
                return operatorF = operatorF + trimElement
            }
        });

        return operatorF;
    } else if (payload.text && payload.text.indexOf('http://') !== -1 || payload.text.indexOf('https://') !== -1) {
        if (payload.text.indexOf('\n') !== -1) {
            const res = payload.text.split('\n').map(item => (<div>{linkUniq(item)}&nbsp;</div>));
            return res;
        } else {
            return linkUniq(payload.text)
        }
    } else {
        if (payload.text && payload.text.indexOf('@') !== -1) {
            let emailTempArr = payload.text.split(' ');
            const createLink = emailTempArr.map(email => {
                if (email.indexOf('@') !== -1) {
                    let mail = email.replace(/mailto:/g, '');
                    if (mail.slice(-1) === '.') {
                        mail = mail.slice(0, -1)
                    }
                    return <a href={`mailto:${mail.trim()}`} target="_blank">{mail.trim()}</a>
                } else {
                    return <span>{email} </span>
                }
            });

            return createLink;
        } else {
            return <SenderWrapper text={payload.text}/>
        }
    }
}

export function PICTURE(payload) {
    if (payload.url) {
        return <div className="sm-picture-header">
            <img src={payload.url} alt="img" className="picture_receiver"/>
        </div>
    }
    return <div className="sm-picture-header">{payload.altText}</div>
}

export function URL(payload) {
    if (payload.url && payload.url.indexOf('http://') !== -1 || payload.url.indexOf('https://') !== -1) {
        let linkTempArr = payload.url.split(' ');
        const createLink = linkTempArr.map(email => {
            if (email.indexOf('http://') !== -1 || email.indexOf('https://') !== -1) {
                return <a href={`${email.trim()}`} target="_blank">{email.trim()}</a>
            } else {
                return email
            }
        });

        return <div className="sm-header__url">{File} {createLink}</div>;
    } else {
        return <div className="sm-header__url">
            <a>{File} {payload.url}</a>
        </div>
    }
}

export function KEYBOARD(payload) {
    return (<div>{PAYLOAD(payload.header)}</div>)
}

export function KEYBOARD_MENU(payload, fn, isShow) {
    let rowCount = Math.max.apply(null, payload.buttons && payload.buttons.map(el => el.row));
    let menus = new Array(rowCount + 1).fill([]);
    const sizeColumn = menuLength => {
        switch (menuLength) {
            case 1:
                return 'sm-size__1';
            case 2:
                return 'sm-size__2';
            case 3:
                return 'sm-size__3';
            case 4:
                return 'sm-size__4';
            case 5:
                return 'sm-size__5';
            case 6:
                return 'sm-size__6';
            default :
                return;
        }
    };

    for (let i = 0; i < menus.length; i++) {
        if (payload.buttons.filter(el => el.row === i)) {
            menus[i] = payload.buttons.filter(el => el.row === i);
        }
    }

    return (<div id="smMenuList" className="sm-menu__list">
        {isShow && menus && menus.length > 0 && menus.map((menu, i) => (
            <div className={`sm-menu__item-row ${sizeColumn(menu.length)}`} key={i}>
                {menu.map((itemCol, iterate) => {
                        let payload = itemCol.payload;

                        return <div className="sm-menu__item-col" key={iterate}>
                            <button
                                style={{
                                    backgroundColor: itemCol.bgColor || window.DEFAULT_BUTTON_BACKGROUND_COLOR || '#01A599',
                                    color: itemCol.fontColor ? itemCol.fontColor : '#fff'
                                }}
                                onClick={() => fn(payload)}>{itemCol.payload.text}</button>
                        </div>
                    }
                )}
            </div>
        ))}
    </div>)
}

export function CAROUSEL(payload, fn, isShow, config) {
    return (<Carousel
        payload={payload}
        fn={fn}
        isShow={isShow}
        config={config}
    />)
}

export function PAYLOAD(data, action, isShow, config, history) {
    if (data) {
        switch (data.type) {
            case "TEXT": {
                if (data.text) {
                    return TEXT(data);
                }
                break;
            }
            case "PICTURE":
                return PICTURE(data);
            case "URL":
            case "FILE":
                return URL(data);
            case "KEYBOARD":
                return KEYBOARD(data);
            case "KEYBOARD_MENU":
                return KEYBOARD_MENU(data, payload => action({
                    message: {id: payload.id, type: "COMMAND", command: "CLICK"},
                    payload: {type: "KEYBOARD_SENDER", payload}
                }), isShow, config, history);
            case "CAROUSEL": {
                return CAROUSEL(data, payload => action({
                    message: {id: payload.text, type: "COMMAND", command: "SELECT"},
                    payload: {type: "CAROUSEL_SENDER", payload}
                }), isShow, config)
            }
            case "EVENT":
            default:
                new Error()
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/Body/payloads.js